export enum BoundaryErrorType {
  SomethingWentWrong = 'SomethingWentWrong',
}
